<template>
  <!-- 回收站-header -->
  <div class="recycle-header">
    <div class="recycle-header-search">
      <a-input-search
          v-model="searchKey"
          class="search-input"
          :placeholder="$t('project.inputSearchKeywords')"
          allow-clear
          @search="handleSearch"
          @pressEnter="handleSearch"
          @clear="handleSearch"
      />
      <AuthControl code="clear_recycle_web">
        <a-button type="primary" @click="handleClearAll" :disabled="isDisabled">
          <svg-icon icon-class="delete" />
          {{ $t('project.clear') }}
        </a-button>
      </AuthControl>
    </div>
    <TipsModal ref="tipsModalRef" />
  </div>
</template>

<script>
import { watch } from 'less'
import TipsModal from './tipsModal.vue'
import { deleteRecycleProject } from '@/api/recycleBin'
export default {
  name: 'RecycleHeader',
  components: {
    TipsModal
  },
  props: {
    tabKey: {
      type: String,
      required: true
    },
    tableList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      searchKey: '',
      isDisabled: false
    }
  },
  computed: {
    userId() {
      const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
      return userInfo.applyAccount || userInfo.userId || null
    }
  },
  watch:{
    tableList(newValue) {
      this.isDisabled = newValue.length === 0
    }
  },
  methods: {
    handleSearch() {
      this.$emit('search', this.searchKey)
    },
    handleClearAll() {
      this.$refs.tipsModalRef.showModal({
        title: this.$t('project.clearRecycleBin'),
        content: this.$t('project.clearRecycleBinTip'),
        icon: 'warn',
        confirmCallback: () => {
          this.clearAll()
        }
      })
    },
    async clearAll(){
      try {
        const payload = {
          account: this.userId,
          isClearAll:0
        }
        const res = await deleteRecycleProject(payload)
        if(res.code === 200 || res.status === 0) {
          this.$message.success('全部清空成功')
          // 刷新列表
          this.$emit('refresh')
        }
      } catch (error) {
        console.error('清空失败:', error)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.recycle-header {
  .tab-nav {
    margin-bottom: 24px;
    /deep/ .ant-radio-button-wrapper {  // 修改: 使用ant-design-vue的类名
      &:first-child {
        border-radius: 2px 0 0 2px;
      }
      &:last-child {
        border-radius: 0 2px 2px 0;
      }
    }
  }
  &-search {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 24px;
    .search-input {
      width: 290px;
      /deep/ .ant-input-search-icon {
        color: #fff;
      }
      /deep/ .ant-input-search-button {  // 修改: 使用ant-design-vue的搜索按钮样式
        height: 32px;
      }
      /deep/ .ant-input-affix-wrapper {  // 修改: 使用ant-design-vue的输入框样式
        border-radius: 2px;
      }
    }
    .ant-btn {  // 修改: 使用ant-design-vue的按钮样式
      border-radius: 2px;
      .svg-icon {
        margin-right: 4px;
        font-size: 14px;
      }
    }
  }
}
</style>